module.exports = __webpack_public_path__ + "img/ios-download.ecc74ae7.png";